import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8)
};

const PRIMARY = {
  lighter: '#E6F3FF',
  light: '#B3D9FF',
  main: '#4A90E2',
  dark: '#2E5BBA',
  darker: '#1E3A8A',
  contrastText: '#fff'
};
const SECONDARY = {
  lighter: '#F8FAFC',
  light: '#CBD5E1',
  main: '#64748B',
  dark: '#475569',
  darker: '#334155',
  contrastText: '#fff'
};
const INFO = {
  lighter: '#E0F2FE',
  light: '#7DD3FC',
  main: '#0EA5E9',
  dark: '#0284C7',
  darker: '#0369A1',
  contrastText: '#fff'
};
const SUCCESS = {
  lighter: '#ECFDF5',
  light: '#86EFAC',
  main: '#10B981',
  dark: '#059669',
  darker: '#047857',
  contrastText: '#fff'
};
const WARNING = {
  lighter: '#FFFBEB',
  light: '#FDE68A',
  main: '#F59E0B',
  dark: '#D97706',
  darker: '#B45309',
  contrastText: '#fff'
};
const ERROR = {
  lighter: '#FEF2F2',
  light: '#FCA5A5',
  main: '#EF4444',
  dark: '#DC2626',
  darker: '#B91C1C',
  contrastText: '#fff'
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
};
const VIOLET ={
  lighter:" #F3E5F5",
  light:"#BA68C8",
  main:"#9C27B0",
  dark:"#7B1FA2",
  darker:"#4A148C",
  contrastText: GREY[800]
 }

const CHART_COLORS = {
  violet: ['#805AD5', '#9F7AEA', '#B794F6', '#D6BCFA'],
  blue: ['#3182CE', '#63B3ED', '#90CDF4', '#BEE3F8'],
  green: ['#38A169', '#68D391', '#9AE6B4', '#C6F6D5'],
  yellow: ['#D69E2E', '#F6E05E', '#FAF089', '#FEFCBF'],
  red: ['#E53E3E', '#FC8181', '#FEB2B2', '#FED7D7']
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  violet:{...VIOLET},
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_24],
  text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
  background: { paper: '#fff', default: '#FAFBFC', neutral: GREY[100] },
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
};

export default palette;
